// extracted by mini-css-extract-plugin
export default {"root":"Header__root--gHWkt","controlsWrapper":"Header__controlsWrapper--3jDI3"};